/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-props-no-spreading */

import cx from 'classnames';
import { Field } from 'formik';
import PropTypes from 'prop-types';
import { Label } from 'reactstrap';

const Checkbox = ({
  simple,
  label,
  labelPosition,
  labelMargin,
  disabled,
  wrapperClassName,
  formInput,
  ...rest
}) => (
  <div className={cx('checkbox-wrapper', wrapperClassName)}>
    <Label className={cx('checkbox-inline', { disabled })}>
      {label && labelPosition === 'left' && <span className="label">{label}</span>}
      {simple ? (
        <input type="checkbox" disabled={disabled} {...rest} />
      ) : (
        <Field type="checkbox" {...rest} disabled={disabled} />
      )}
      <span
        style={{
          ...(labelPosition === 'left'
            ? { marginLeft: labelMargin }
            : { marginRight: labelMargin }),
        }}
      >
        <i className="facheck" />
      </span>
      {label && labelPosition === 'right' && <span className="label">{label}</span>}
    </Label>
  </div>
);

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  label: PropTypes.string,
  simple: PropTypes.bool,
  disabled: PropTypes.bool,
  labelMargin: PropTypes.number,
  wrapperClassName: PropTypes.string,
  labelPosition: PropTypes.string,
};

Checkbox.defaultProps = {
  simple: false,
  disabled: false,
  labelMargin: 10,
  wrapperClassName: '',
  label: '',
  labelPosition: 'left',
};

export default Checkbox;
